module.exports = __webpack_public_path__ + "img/process-img-1.c81a044b.png";